import React from 'react';
import {
  NameBox,
  NameCard,
  Image,
  Name,
  DetailsCard,
  ContactText,
  FullLine,
  ColoredLine,
  ParentLine,
  UserDetailsBox,
  Infocard,
  Label,
  Value,
  DetailsBox,
  Status,
  SaveButton,
  DeleteButton,
  DetailButtonBox,
  DialogContainer,
  DialogButtonBox,
  SavingIndicator,
  CancelButton,
  UserEmailComp,
  CompanyData,
} from './users-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faCircleNotch,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons';
import { primaryColor } from '@app/styles';
import { StatusBar, Button, Dialog } from '@app/components';
import { UserInfo } from '@app/types';
import { useDeleteUserQuery } from '@app/graphql';
import { numberFormat } from '@app/utils';
import {
  MobileDropdown,
  MobileDropdownOption,
  MobileHeader,
  MobileOptions,
} from '@app/modules/user-management/users-components';
type Props = {
  userDetails?: UserInfo;
  onEditUserClick: () => void;
  onDeleteUser: (e: any) => void;
  onBackClick?: () => void;
};
const MenuIconStyle = {
  height: 50,
  width: 30,
};

const UserDetails = ({
  userDetails,
  onEditUserClick,
  onDeleteUser,
  onBackClick,
}: Props) => {
  const [showDeleteDialog, setShowDeleteDialog] = React.useState<boolean>(
    false,
  );
  const [isMobile, setIsMobile] = React.useState(
    window.innerWidth < 768 ? true : false,
  );
  const [showSideNav, toggleSideNav] = React.useState(false);
  const [saving, updatesaving] = React.useState<boolean>(false);
  const [DeleteUser] = useDeleteUserQuery();
  const [userData, setUserData] = React.useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    type: '',
    image: '',
    municipality: '',
    status: '',
    firebaseId: '',
    userRole: '',
  });
  const sideNavRef: any = React.useRef(null);
  function handleClickOutside(e: any) {
    if (
      showSideNav &&
      sideNavRef.current &&
      !sideNavRef.current.contains(e.target)
    ) {
      toggleSideNav(false);
    }
  }
  document.addEventListener('click', handleClickOutside);
  window.addEventListener('resize', function() {
    if (window.innerWidth > 768) {
      setIsMobile(false);
    } else if (window.innerWidth < 768) {
      setIsMobile(true);
    }
  });
  React.useEffect(() => {
    if (userDetails) {
      const {
        firstName = '',
        lastName = '',
        email = '',
        // company = '',
        phone = '',
        userType = '',
        profilePicUrl = '',
        municipalityName = '',
        status = '',
        firebaseId = '',
        titleCompany = '',
        userTypeData = '',
        roleData = '',
      } = userDetails;

      setUserData({
        name: `${firstName} ${lastName}`,
        company: titleCompany,
        phone: phone,
        email: email,
        type: userTypeData && userTypeData.name ? userTypeData.name : userType,
        image: profilePicUrl,
        municipality: municipalityName,
        status: status,
        firebaseId: firebaseId,
        userRole: roleData && roleData.name ? roleData.name : '',
      });
    }

    // eslint-disable-next-line
  }, [userDetails]);

  const deleteUser = () => {
    updatesaving(true);
    DeleteUser({ variables: { firebaseId: userData.firebaseId } })
      .then((res: any) => {
        const {
          deleteUser: { success, user = {} },
        } = res.data;
        if (success) {
          onDeleteUser({
            type: 'delete',
            user: user,
          });
          updatesaving(false);
          setShowDeleteDialog(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  const ArrowStyle = {
    cursor: 'pointer',
    marginRight: '5px',
  };
  return (
    <>
      <NameBox>
        <NameCard>
          {isMobile ? (
            <FontAwesomeIcon
              icon={faArrowLeft}
              onClick={onBackClick}
              size="lg"
              style={ArrowStyle}
            />
          ) : null}
          <Image image={userData.image} />
          <Name>{userData.name}</Name>
          <Status>
            {userData.status && (
              <StatusBar
                variant={
                  userData.status === 'ACTIVE' ? 'primary' : 'secondary'
                }>
                {userData.status}
              </StatusBar>
            )}
          </Status>
        </NameCard>
        {isMobile ? (
          <MobileHeader ref={sideNavRef}>
            <FontAwesomeIcon
              color={'#000000'}
              icon={faEllipsisH}
              style={MenuIconStyle}
              onClick={() => {
                toggleSideNav(!showSideNav);
              }}
            />
          </MobileHeader>
        ) : null}
        {showSideNav ? (
          <MobileDropdown>
            <MobileOptions>
              <MobileDropdownOption
                onClick={() => {
                  onEditUserClick();
                }}>
                Edit
              </MobileDropdownOption>
              <MobileDropdownOption
                onClick={() => {
                  setShowDeleteDialog(true);
                }}>
                Delete
              </MobileDropdownOption>
            </MobileOptions>
          </MobileDropdown>
        ) : null}
        {!isMobile ? (
          <DetailButtonBox>
            <SaveButton>
              <Button
                variant="primary"
                size="medium"
                width="100%"
                type="submit"
                onClick={() => {
                  onEditUserClick();
                }}>
                Edit
              </Button>
            </SaveButton>
            <DeleteButton>
              <Button
                variant="secondary"
                size="medium"
                width="100%"
                type="submit"
                onClick={() => {
                  setShowDeleteDialog(true);
                }}>
                Delete
              </Button>
            </DeleteButton>
          </DetailButtonBox>
        ) : null}
      </NameBox>
      <DetailsCard>
        <ContactText>Contact Details</ContactText>
        <ParentLine>
          <FullLine />
          <ColoredLine />
        </ParentLine>
      </DetailsCard>
      <UserDetailsBox>
        <DetailsBox>
          <Infocard>
            <Label>User Type</Label>
            <Value>{userData.type}</Value>
          </Infocard>
          <Infocard>
            <Label>User Role</Label>
            <Value>{userData.userRole || '--'}</Value>
          </Infocard>
        </DetailsBox>
        <DetailsBox>
          <Infocard>
            <Label>Name</Label>
            <Value>{userData.name}</Value>
          </Infocard>
          {userData.company && (
            <CompanyData>
              <Label>Company</Label>
              <Value>{userData.company ? userData.company : '- -'}</Value>
            </CompanyData>
          )}
          {userData.municipality && (
            <CompanyData>
              <Label>Municipality</Label>
              <Value>
                {userData.municipality ? userData.municipality : '- -'}
              </Value>
            </CompanyData>
          )}
        </DetailsBox>
        <DetailsBox>
          <Infocard>
            <Label>Phone Number</Label>
            <Value>
              {userData.phone ? numberFormat(userData.phone) : '- -'}
            </Value>
          </Infocard>
          <UserEmailComp>
            <Label>Email</Label>
            <Value>{userData.email}</Value>
          </UserEmailComp>
        </DetailsBox>
      </UserDetailsBox>
      {showDeleteDialog && (
        <Dialog
          size="small"
          onClose={() => {
            setShowDeleteDialog(false);
          }}>
          <DialogContainer>
            <Value>Are you sure you want to delete {userData.name}?</Value>
            <DialogButtonBox>
              {saving && (
                <SavingIndicator>
                  <FontAwesomeIcon
                    color={primaryColor}
                    icon={faCircleNotch}
                    size="lg"
                    spin
                  />
                </SavingIndicator>
              )}
              <CancelButton disabled={saving}>
                <Button
                  variant="text"
                  size="medium"
                  onClick={() => {
                    setShowDeleteDialog(false);
                  }}>
                  Cancel
                </Button>
              </CancelButton>
              <SaveButton disabled={saving}>
                <Button
                  variant="primary"
                  size="medium"
                  width="100%"
                  type="submit"
                  onClick={deleteUser}>
                  {saving ? 'Deleting...' : 'Delete'}
                </Button>
              </SaveButton>
            </DialogButtonBox>
          </DialogContainer>
        </Dialog>
      )}
    </>
  );
};

export default UserDetails;
